<template>
	<article class='xbed-oms-content'>
		<section class="xbed-sub-title">
			<span>网络开门申请</span>
		</section>
		<section style='marginTop:20px'>
			<Form :model='openDoorOnline' ref='openDoorOnline'>
				<Row>
					<Col span="5">
						<FormItem prop='' label='订单号：' :label-width='120'>
							<Input type='text' v-model='openDoorOnline.orderNo'></Input>
						</FormItem>
					</Col>
					<Col span="5">
						<FormItem prop='' label='门锁ID：' :label-width='120'>
							<Input type='text' v-model='openDoorOnline.lockId'></Input>
						</FormItem>
					</Col>
					<Col span="5">
						<FormItem prop='' label='Xbed房间ID：' :label-width='120'>
							<Input type='text' v-model='openDoorOnline.xbedRoomId'></Input>
						</FormItem>
					</Col>
					<Col span="5">
						<FormItem prop='' label='门店名称：' :label-width='120'>
							<Input type='text' v-model='openDoorOnline.chainName'></Input>
						</FormItem>
					</Col>
					<Col span="5">
						<FormItem prop='' label='操作人：' :label-width='120'>
							<Input type='text' v-model='openDoorOnline.handlerName'></Input>
						</FormItem>
					</Col>
					<Col span="5">
						<FormItem prop='' label='开门类型：' :label-width='120'>
							<Select v-model="openDoorOnline.openType" clearable placeholder="全部">
								<Option v-for="item in openType" :key="item.id" :value="item.id">{{item.name}}</Option>
							</Select>
						</FormItem>
					</Col>
					<Col span="5">
						<FormItem prop='' label='城市：' :label-width='120'>
							<Select v-model="openDoorOnline.city" clearable filterable placeholder="全部">
								<Option v-for="city in allCities" :key="city" :value="city">{{city}}</Option>
							</Select>
						</FormItem>
					</Col>
					<Col span='5'>
						<FormItem prop='' label='开门结果：' :label-width='120'>
							<Select v-model='openDoorOnline.openResult' clearable placeholder="全部">
								<Option v-for='result in openResult' :key='result.id' :value='result.id'>{{result.name}}</Option>
							</Select>
						</FormItem>
					</Col>
					<Col span='5'>
						<FormItem prop='' label='操作终端：' :label-width='120'>
							<Select v-model='openDoorOnline.terminalOperation' clearable placeholder="全部">
								<Option v-for='terminal in terminalOperation' :key='terminal.id' :value='terminal.id'>{{terminal.name}}</Option>
							</Select>
						</FormItem>
					</Col>
					<Col span='7'>
						<FormItem prop='' label='操作时间：' :label-width='120'>
							<date-picker type='daterange' :model='openDoorOnline.datePick' :value='openDoorOnline.datePick' @on-change="datepick" style='width:100%'></date-picker>
						</FormItem>
					</Col>
					<Col span='3' offset="2">
						<FormItem>
							<Button type='primary' @click='queryOpenDoorList'>查询</Button>
						</FormItem>
					</Col>
					<Col span='3'>
						<FormItem>
							<Button type='primary' @click='exportOpenList' :loading="exportBtn">导出筛选结果</Button>
						</FormItem>
					</Col>
				</Row>
				<Table stripe :loading='openListLoading' :columns="openDoorOnlineList" :data="openDoorOnlineListData.list">
				</Table>
				<div style="margin: 10px;overflow: hidden">
					<Page show-sizer placement="top" show-total :total="openDoorOnlineListData.total" :current="openDoorOnline.page" :page-size="openDoorOnline.pageSize" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
				</div>
			</Form>
		</section>
	</article>
</template>
<script>
import Moment from 'moment';
import API from "../../../api";
import Utils from '../../../utils';
import Config from '../../../config'

export default {
	data() {
		return {
			exportBtn: false,
			tableWidth: 0,
			openListLoading: false,
			openDoorOnline: {
				datePick: [Moment().subtract( 1, 'days' ).format( 'YYYY-MM-DD' ), Moment().format( 'YYYY-MM-DD' )],
				openResult: '',
				terminalOperation: '',
				handlerName: '',
				chainName: '',
				city: '',
				lockId: '',
				orderNo: '',
				openType: '',
				xbedRoomId: ''
			},
			openType: [
				{
					name: '访客看房',
					id: 1
				}, {
					name: '管家查房',
					id: 2
				}, {
					name: '检修设备',
					id: 3
				}, {
					name: '补充物质',
					id: 4
				}, {
					name: '清洁打扫',
					id: 5
				}, {
					name: '入住门锁异常',
					id: 6
				}, {
					name: '物品遗留',
					id: 7
				}, {
					name: '延迟退房',
					id: 8
				}, {
					name: '其他',
					id: 9
				}
			],
			allCities: [],
			openResult: [
				{
					name: '开门成功',
					id: 1
				},
				{
					name: '开门失败',
					id: 0
				}
			],
			terminalOperation: [

			],
			openDoorOnlineListData: {
				page: 1,
				pageSize: 10
			},
			openDoorOnlineList: [
				{
					title: '订单号',
					key: 'orderNo',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.orderNo || '-' )
					}
				},
				{
					title: '门锁ID',
					key: 'lockId',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.lockId || '-' )
					}
				},
				{
					title: '城市',
					key: 'city',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.city || '-' )
					}
				},
				{
					title: '门店名称',
					key: 'chainName',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.chainName || '-' )
					}
				},
				{
					title: 'Xbed房间ID',
					key: 'roomId',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.roomId || '-' )
					}
				},
				{
					title: 'Xbed房名',
					key: 'custRoomName',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.custRoomName || '-' )
					}
				}, {
					title: '房间号',
					key: 'custRoomNo',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.custRoomNo || '-' )
					}
				}, {
					title: '开门类型',
					key: 'openType',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.openType || '-' )
					}
				}, {
					title: '开门备注',
					key: 'custRemark',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.custRemark || '-' )
					}
				}, {
					title: '操作人',
					key: 'handlerName',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.handlerName || '-' )
					}
				}, {
					title: '操作时间',
					key: 'createTime',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.createTime || '-' )
					}
				}, {
					title: '开门结果',
					key: 'isSuccess',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, ['开门失败', '开门成功'][params.row.isSuccess] || '-' )
					}
				}, {
					title: '操作端口',
					key: 'operatSource',
					minWidth: 150,
					align: 'center',
					render( h, params ) {
						return h( 'div', {}, params.row.operatSource || '-' )
					}
				}
			]
		}
	},
	created() {
		this.token = Utils.findFromLocalStorage( 'vue-token' );
		this.env = Utils.findFromLocalStorage( 'env', 'dev' );
		this.userId = Utils.findFromLocalStorage( 'vue-userid' );
		// this.tableWidth = window.screen.width - 235;
		this.analysisUrl = Config[this.env].analysisUrl;
		this.queryOpenList( true );
		this.quertSource();
	},
	async mounted() {
		let selectListResp = ( await API.omsAPI[this.env].php.querySelectList() ).data;
		this.allCities = selectListResp.data.city;
		this.$Notice.config( {
			top: 100
		} )
	},
	methods: {
		async quertSource() {
			try {
				let resp = ( await API.omsAPI[this.env].deviceModule.remoteOpenDoorApi(
					{'url': '/lockApi/openRoomType'}, 'get', {},
					this.token
				) ).data;
				resp.map( item => {
					this.terminalOperation.push(
						{
							name: item,
							id: item
						}
					)
				} )
			} catch ( error ) {
				console.info( error );
				this.$Notice.error( {
					title: '获取操作终端数据失败',
					desc: error.msg
				} )
			}
		},
		datepick( dataArr ) {
			this.openDoorOnline.datePick = dataArr;
		},
		queryOpenDoorList() {
			this.openDoorOnlineListData.page = 1;
			this.queryOpenList()
		},
		regParams() {
			let params = this.openDoorOnline;
			let reg = new RegExp( /^[0-9]*$/ );
			if ( params.lockId && !reg.test( params.lockId ) || params.xbedRoomId && !reg.test( params.xbedRoomId ) ) {
				return [false, '门锁和XbedID字段只能输入数字，且需小于10个字符']
			}
			if ( params.lockId && params.lockId.trim() - 1000000000 >= 0 ) {
				return [false, '门锁字段需小于10个字符']
			}
			if ( params.xbedRoomId && params.xbedRoomId.trim() - 1000000000 >= 0 ) {
				return [false, 'XbedID字段需小于10个字符']
			}
			if ( params.handlerName && params.handlerName.trim().length > 50 ) {
				return [false, '操作人字段不能超过50个字符']
			}
			if ( !params.datePick[1] || !params.datePick[0] ) {
				return [false, '查询时间不能为空']
			}
			let endDate = params.datePick[1].split( '-' );
			let startDate = params.datePick[0].split( '-' );
			if ( endDate[0] - startDate[0] > 1
				|| ( endDate[0] - startDate[0] === 1 && endDate[1] - startDate[1] > 0 )
				|| ( endDate[0] - startDate[0] === 1 && endDate[1] - startDate[1] === 0 && endDate[2] - startDate[2] > 0 ) ) {
				return [false, '查询时间不能超过一年']
			}
			console.info( endDate, startDate )

			if ( !params.datePick[1] || !params.datePick[0] ) {
				return [false, '查询时间不能为空']
			}
			return [true, '']
		},
		async queryOpenList( isInit = false ) {
			if ( !isInit ) {
				let isReg = this.regParams();
				if ( !isReg[0] ) {
					this.$Notice.error( {
						title: '查询失败',
						desc: isReg[1]
					} )
					return
				}
			}
			this.openListLoading = true;
			let param = {
				chainName: this.openDoorOnline.chainName.trim(),
				city: this.openDoorOnline.city.trim(),
				handlerName: this.openDoorOnline.handlerName.trim(),
				isSuccess: this.openDoorOnline.openResult,
				lockId: this.openDoorOnline.lockId.trim(),
				operatSource: this.openDoorOnline.terminalOperation,
				operatTimeEnd: this.openDoorOnline.datePick[1],
				operatTimeSta: this.openDoorOnline.datePick[0],
				orderNo: this.openDoorOnline.orderNo.trim(),
				openType: this.openDoorOnline.openType,
				roomId: this.openDoorOnline.xbedRoomId.trim(),
				pageNum: this.openDoorOnlineListData.page,
				pageSize: this.openDoorOnlineListData.pageSize
			}
			for ( let key in param ) {
				if ( !param[key] && param[key] !== 0 && param[key] !== '0' ) {
					delete param[key];
				}
			}
			param.url = '/lockApi/openRoomLockLog'
			try {
				let resp = ( await API.omsAPI[this.env].deviceModule.remoteOpenDoorApi(
					{}, 'post', param,
					this.token
				) ).data;
				this.openListLoading = false;
				if ( resp.retCode ) {
					this.$Notice.error( {
						title: '查询失败',
						desc: resp.msg
					} )
					return ''
				}
				this.openDoorOnlineListData = resp;
			} catch ( error ) {
				console.info( error )
				this.$Notice.error( {
					title: '查询失败',
					desc: error.msg
				} )
			}

		},
		async exportOpenList() {   // 导出Excel还没做
			let param = {
				chainName: this.openDoorOnline.chainName,
				city: this.openDoorOnline.city,
				handlerName: this.openDoorOnline.handlerName,
				isSuccess: this.openDoorOnline.openResult,
				lockId: this.openDoorOnline.lockId,
				operatSource: this.openDoorOnline.terminalOperation,
				operatTimeEnd: this.openDoorOnline.datePick[1],
				operatTimeSta: this.openDoorOnline.datePick[0],
				orderNo: this.openDoorOnline.orderNo,
				openType: this.openDoorOnline.openType,
				roomId: this.openDoorOnline.xbedRoomId,
			}
			let queryParams = ''
			for ( let key in param ) {
				if ( !param[key] && param[key] !== 0 && param[key] !== '0' ) {
					delete param[key];
				}
				else {
					queryParams += `${ key }=${ param[key] }&`
				}
			}
			let exportUrl = this.analysisUrl + 'excel/exportRemoteOpenLog?' + queryParams
			// window.open(exportUrl ,"_blank")
			Utils.exportExcelWeighting( exportUrl, this.token, this.$Notice.error, this, "exportBtn" )

		},
		changePageSize( pageSize ) {
			this.openDoorOnlineListData.page = 1;
			this.openDoorOnlineListData.pageSize = pageSize
			this.queryOpenList();
		},
		changePage( pageIndex ) {
			this.openDoorOnlineListData.page = pageIndex;
			this.queryOpenList();
		},
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/smart-device/open-online/index.vue